import { request } from "./client";
import type { ProfileStats } from "./types";

export async function getProfileStats(): Promise<ProfileStats> {
  return request<ProfileStats>({ method: "GET", url: "/profile/stats" });
}
